import React from 'react';
import Layout from "../../../components/Wrappers/Layout";
import WithdrawEMoneyFilter from './WithdrawEMoneyFilter';
import WithdrawEMoneyList from './WithdrawEMoneyList';

function BankWithdrawEMoney() {
  return (
	<Layout>
		<WithdrawEMoneyFilter />
		<WithdrawEMoneyList />
	</Layout>
  )
}

export default BankWithdrawEMoney